import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const GeoLeads = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default GeoLeads